import { render } from "./PCAccessDeviceDetail.vue?vue&type=template&id=a0fa4690"
import script from "./PCAccessDeviceDetail.vue?vue&type=script&lang=js"
export * from "./PCAccessDeviceDetail.vue?vue&type=script&lang=js"

import "./PCAccessDeviceDetail.vue?vue&type=style&index=0&id=a0fa4690&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__